import { defineMessages } from 'react-intl';

import {
  BasketballAverageStatType,
  NBAPosition,
  Position,
  So5LeaderboardType,
} from '#src/__generated__/globalTypes.ts';

export const positionNames = defineMessages<NBAPosition>({
  [NBAPosition.GUARD]: {
    defaultMessage: 'Guard',
  },
  [NBAPosition.CENTER]: {
    defaultMessage: 'Center',
  },
  [NBAPosition.FORWARD]: {
    defaultMessage: 'Forward',
  },
  [NBAPosition.UNKNOWN]: {
    defaultMessage: 'Unknown',
  },
});

type PlayerInjuryStatus = 'GTD' | 'OUT' | 'OFS';

const shortMessages = defineMessages<PlayerInjuryStatus>({
  GTD: {
    defaultMessage: 'GTD',
  },
  OUT: {
    defaultMessage: 'OUT',
  },
  OFS: {
    defaultMessage: 'OFS',
  },
});

const longMessages = defineMessages({
  GTD: {
    defaultMessage: 'Game Time Decision',
  },
  OUT: {
    defaultMessage: 'Out',
  },
  OFS: {
    defaultMessage: 'Out For Season',
  },
});

export function getPlayerInjuryMessage(
  status: string | null,
  { long }: { long?: boolean } = {}
) {
  const messages = long ? longMessages : shortMessages;
  switch (status) {
    case 'GTD':
      return messages.GTD;
    case 'OFS':
      return messages.OFS;
    default:
    case 'OUT':
      return messages.OUT;
  }
}

type PlayerInjuryColor = 'yellow' | 'red';

const PLAYER_INJURY_COLORS_BY_STATUS: Record<
  PlayerInjuryStatus,
  PlayerInjuryColor
> = {
  GTD: 'yellow',
  OUT: 'red',
  OFS: 'red',
};

export function getPlayerInjuryColor(status: string | null): PlayerInjuryColor {
  return PLAYER_INJURY_COLORS_BY_STATUS[status as PlayerInjuryStatus] ?? 'red';
}

export const randomNbaPositions = () => {
  const positions = [
    Position.basketball_center,
    Position.basketball_forward,
    Position.basketball_guard,
  ];
  return positions[Math.floor(Math.random() * positions.length)];
};

export const shortNbaStats = {
  [BasketballAverageStatType.POINTS]: 'PTS',
  [BasketballAverageStatType.REBOUNDS]: 'REB',
  [BasketballAverageStatType.MINS_PLAYED]: 'MIN',
  [BasketballAverageStatType.STEALS]: 'STL',
  [BasketballAverageStatType.ASSISTS]: 'AST',
  [BasketballAverageStatType.BLOCKS]: 'BLK',
  [BasketballAverageStatType.TURNOVERS]: 'TO',
  [BasketballAverageStatType.THREE_POINTS_MADE]: '3PT',
  [BasketballAverageStatType.DOUBLE_DOUBLE]: 'DD',
  [BasketballAverageStatType.TRIPLE_DOUBLE]: 'TD',
};

export const dailyHoopsTournamentTypes: So5LeaderboardType[] = [
  So5LeaderboardType.NBA_COMMON_DAILY_HOOPS,
  So5LeaderboardType.NBA_LIMITED_DAILY_HOOPS,
  So5LeaderboardType.NBA_RARE_DAILY_HOOPS,
  So5LeaderboardType.NBA_SUPER_RARE_DAILY_HOOPS,
  So5LeaderboardType.NBA_UNIQUE_DAILY_HOOPS,
];
